export const replaceEngineerCompanyName = (name: string) => {
  // 末尾の全角括弧（エンジニア）と半角括弧(エンジニア)を削除
  return name.replace(/（エンジニア）$/, '').replace(/\(エンジニア\)$/, '');
};
